import SetPasswordForm from "@/features/auth/set-password/components/SetPasswordForm";

export default function SetPassword() {
  return <SetPasswordForm />;
}
